interface ApiErrorLike {
  message?: unknown
  response?: { data?: { message?: unknown } }
}

const readMessage = (value: unknown): string | null =>
  typeof value === 'string' && value.trim() !== '' ? value.trim() : null

export const getApiErrorMessage = (error: unknown, fallback: string): string => {
  const forwarded = readMessage(error)
  if (forwarded) return forwarded

  if (typeof error !== 'object' || error === null) return fallback

  const candidate = error as ApiErrorLike

  return (
    readMessage(candidate.response?.data?.message) ??
    readMessage(candidate.message) ??
    fallback
  )
}
